// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","443":"about"}[chunkId] || chunkId) + "." + {"36":"eef1b7a0","177":"16218362","443":"7cc1d019"}[chunkId] + ".js";
};